import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchDeliverySettingMiniEntity } from '../../domain/entities/BranchDeliverySettingMiniEntity'

export class BranchDeliverySettingMiniModel extends BranchDeliverySettingMiniEntity {
  constructor(dataDto: BranchDeliverySettingMiniEntity) {
    super()
    mapEntityProperties<BranchDeliverySettingMiniModel>(this, dataDto)
  }
}
